(function () {
  var MESI = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];
  var GIORNI = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
  var now = new Date();

  // Ad click params (utm, fbclid) follow the reader to the product page.
  var qs = window.location.search.replace(/^\?/, "");
  document.querySelectorAll("a[data-cta]").forEach(function (a) {
    if (qs) a.href += (a.href.indexOf("?") > -1 ? "&" : "?") + qs;
    a.addEventListener("click", function () {
      if (window.fbq) fbq("trackCustom", "ListicleClick", { page: location.pathname });
    });
  });

  document.querySelectorAll("[data-today]").forEach(function (el) {
    el.textContent = now.getDate() + " " + MESI[now.getMonth()] + " " + now.getFullYear();
  });
  document.querySelectorAll("[data-year]").forEach(function (el) { el.textContent = now.getFullYear(); });

  // The offer ends next Sunday at 23:59 (local time), so the countdown always shows 1-7 days.
  var end = new Date(now);
  end.setDate(now.getDate() + ((7 - now.getDay()) % 7));
  end.setHours(23, 59, 59, 0);
  var label = GIORNI[end.getDay()] + " " + end.getDate() + " " + MESI[end.getMonth()];
  document.querySelectorAll("[data-deadline]").forEach(function (el) { el.textContent = label; });

  var cd = document.querySelector("[data-countdown]");
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function tick() {
    if (!cd) return;
    var s = Math.max(0, Math.floor((end - new Date()) / 1000));
    cd.querySelector("[data-d]").textContent = pad(Math.floor(s / 86400));
    cd.querySelector("[data-h]").textContent = pad(Math.floor(s % 86400 / 3600));
    cd.querySelector("[data-m]").textContent = pad(Math.floor(s % 3600 / 60));
    cd.querySelector("[data-s]").textContent = pad(s % 60);
  }
  tick(); setInterval(tick, 1000);

  // Sticky offer bar: shown once the hero is out of view, hidden while the offer box is on screen.
  var sticky = document.querySelector("[data-sticky]");
  var hero = document.querySelector(".hero");
  var offer = document.querySelector(".offer");
  var heroGone = false, offerVisible = false;
  function update() { sticky.classList.toggle("show", heroGone && !offerVisible); }
  if (sticky && "IntersectionObserver" in window) {
    new IntersectionObserver(function (e) { heroGone = !e[0].isIntersecting; update(); }).observe(hero);
    if (offer) new IntersectionObserver(function (e) { offerVisible = e[0].isIntersecting; update(); }).observe(offer);
  }
})();
